module.exports = __webpack_public_path__ + "img/myhome.e0ad9358.svg";